import { Injectable, inject } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Subject } from 'rxjs';

import { EnvironmentService } from './environment.service';
import { AppSessionStorage } from './storage/app.session-storage';

@Injectable({
    providedIn: 'root'
})
export class SignalRService {
    readonly onMessageReceived = new Subject<string>();
    readonly onConnection = new Subject<any>();
    readonly onDisconnected = new Subject<void>();

    private hubConnection: HubConnection;

    private readonly environmentService = inject(EnvironmentService);
    private readonly appSessionStorage = inject(AppSessionStorage);

    startConnection(channel: string, recipient = ''): void {
        const tenant = `${this.appSessionStorage.getCurrentContext()}`;
        this.hubConnection = new HubConnectionBuilder()
            .withUrl(this.environmentService.baseUrl + '/api/signalr' + `?t=${tenant}&r=${recipient}&c=${channel}`, {
                withCredentials: false
            })
            .build();

        this.hubConnection.on('BroadcastMessage', (message: string) => {
            this.onMessageReceived.next(message);
        });
        this.hubConnection.onclose(() => this.onDisconnected.next());
        this.hubConnection
            .start()
            .then(() => this.onConnection.next(undefined))
            .catch(err => {
                this.onConnection.next(err);
                console.error('Error while starting connection: ' + err);
            });
    }

    stopConnection(): void {
        this.hubConnection.stop();
    }
}
